import React from 'react';
import _ from 'lodash';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

class Cat extends PositionedGoodyHOC {
	render() {
		return (
			<g>
				<g>
					<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="54.34491" cy="70.13715" />
					<circle fill="#D1AF79" cx="55.45789" cy="8.15383" r="7.21167" />
					<path fill="#D1AF79" d="M55.53143,46.93857c30.58903,0,46.57311,8.47895,54.56702,24.87725
					c0.46561,0.95515,0.09139,2.15963-0.81834,2.5372c-3.48103,1.44474-44.50916,9.20248-52.47595,10.70139
					c-0.8861,0.16672-1.78472,0.16689-2.67088,0.0005C46.1673,83.55922,5.14824,75.81929,1.65135,74.37982
					c-0.91846-0.37807-1.30094-1.59112-0.83702-2.55795C8.68041,55.42865,24.93669,46.93857,55.53143,46.93857" />
					<path fill="#D1AF79" d="M98.25116,57.63715H12.66461l3.22204-20.48726c1.13537-6.86683,7.58776-29.3209,39.54546-29.3209
					s38.46094,22.44992,39.597,29.3209L98.25116,57.63715z" />
					<path fill="#75C69F" d="M85.63464,50.79567c-0.68115-2.61401-0.80676-4.83521-0.80261-6.96436
					c0.03418-2.10791,0.2644-4.07715,0.68213-5.91382c0.82275-3.68213,2.30664-6.89624,4.26831-9.7727
					c1.96118-2.87646,4.45764-5.37427,7.64233-7.38501c1.59412-1.00415,3.36829-1.88086,5.36877-2.59741
					c1.02112-0.34351,2.0636-0.67212,3.21643-0.92236c1.12524-0.26978,2.37561-0.45117,3.75305-0.54248
					c0.37207,1.32935,0.61707,2.56885,0.73694,3.71973c0.14746,1.17041,0.18457,2.2627,0.20044,3.34009
					c-0.01025,2.12476-0.24683,4.0896-0.66345,5.927c-0.83667,3.67236-2.36169,6.85742-4.42175,9.66406
					c-2.05994,2.80664-4.59729,5.27539-7.7959,7.27637c-1.59314,1.00488-3.37354,1.8772-5.3501,2.61084
					C90.46276,49.94777,88.32641,50.56837,85.63464,50.79567z" />
					<path fill="#66AA88" d="M109.76305,16.69752c0.37207,1.32935,0.61707,2.56885,0.73694,3.71973
					c0.14746,1.17041,0.18457,2.2627,0.20044,3.34009c-0.01025,2.12476-0.24683,4.0896-0.66345,5.927
					c-0.83667,3.67236-2.36169,6.85742-4.42175,9.66406c-2.05994,2.80664-4.59729,5.27539-7.7959,7.27637
					c-1.59314,1.00488-3.37354,1.8772-5.3501,2.61084c-2.00647,0.71216-4.14282,1.33276-6.83459,1.56006" />
					<path fill="#75C69F" d="M110.19787,28.87257c0.24731-1.2749,0.40796-2.61133,0.46802-4.01855l-7.91322,3.87428
					c-0.38662,0.18929-0.22589,0.77333,0.20314,0.73815L110.19787,28.87257z" />
					<path fill="#75C69F" d="M108.0061,35.4048c0.55676-1.12891,1.03625-2.31226,1.43225-3.55493l-0.01074-0.06299l-8.6692,0.81651
					c-0.43028,0.04053-0.48436,0.64713-0.06802,0.76312L108.0061,35.4048z" />
					<polygon fill="#AD6636" points="12.71546,57.31354 98.20032,57.31354 96.62756,47.31354 14.28821,47.31354 	" />
				</g>
			</g>
		);
	}
}

class Tortoise extends PositionedGoodyHOC {
	render() {
		return (
			<g transform="scale(0.75) translate(18.5 28)">
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="57.34491" cy="78.13715" />
				<circle fill="#D1AF79" cx="55.45789" cy="8.15383" r="7.21167" />
				<path fill="#D1AF79" d="M55.53143,46.93857c30.58903,0,46.57311,8.47895,54.56702,24.87725
				c0.46561,0.95515,0.09139,2.15963-0.81834,2.5372c-3.48103,1.44474-44.50916,9.20248-52.47595,10.70139
				c-0.8861,0.16672-1.78472,0.16689-2.67088,0.0005C46.1673,83.55922,5.14824,75.81929,1.65135,74.37982
				c-0.91846-0.37807-1.30094-1.59112-0.83702-2.55795C8.68041,55.42865,24.93669,46.93857,55.53143,46.93857" />
				<path fill="#D1AF79" d="M98.25116,57.63715H12.66461l3.22204-20.48726c1.13537-6.86683,7.58776-29.3209,39.54546-29.3209
				s38.46094,22.44992,39.597,29.3209L98.25116,57.63715z" />
				<path fill="#75C69F" d="M85.63464,50.79567c-0.68115-2.61401-0.80676-4.83521-0.80261-6.96436
				c0.03418-2.10791,0.2644-4.07715,0.68213-5.91382c0.82275-3.68213,2.30664-6.89624,4.26831-9.7727
				c1.96118-2.87646,4.45764-5.37427,7.64233-7.38501c1.59412-1.00415,3.36829-1.88086,5.36877-2.59741
				c1.02112-0.34351,2.0636-0.67212,3.21643-0.92236c1.12524-0.26978,2.37561-0.45117,3.75305-0.54248
				c0.37207,1.32935,0.61707,2.56885,0.73694,3.71973c0.14746,1.17041,0.18457,2.2627,0.20044,3.34009
				c-0.01025,2.12476-0.24683,4.0896-0.66345,5.927c-0.83667,3.67236-2.36169,6.85742-4.42175,9.66406
				c-2.05994,2.80664-4.59729,5.27539-7.7959,7.27637c-1.59314,1.00488-3.37354,1.8772-5.3501,2.61084
				C90.46276,49.94777,88.32641,50.56837,85.63464,50.79567z" />
				<path fill="#66AA88" d="M109.76305,16.69752c0.37207,1.32935,0.61707,2.56885,0.73694,3.71973
				c0.14746,1.17041,0.18457,2.2627,0.20044,3.34009c-0.01025,2.12476-0.24683,4.0896-0.66345,5.927
				c-0.83667,3.67236-2.36169,6.85742-4.42175,9.66406c-2.05994,2.80664-4.59729,5.27539-7.7959,7.27637
				c-1.59314,1.00488-3.37354,1.8772-5.3501,2.61084c-2.00647,0.71216-4.14282,1.33276-6.83459,1.56006" />
				<path fill="#75C69F" d="M110.19787,28.87257c0.24731-1.2749,0.40796-2.61133,0.46802-4.01855l-7.91322,3.87428
				c-0.38662,0.18929-0.22589,0.77333,0.20314,0.73815L110.19787,28.87257z" />
				<path fill="#75C69F" d="M108.0061,35.4048c0.55676-1.12891,1.03625-2.31226,1.43225-3.55493l-0.01074-0.06299l-8.6692,0.81651
				c-0.43028,0.04053-0.48436,0.64713-0.06802,0.76312L108.0061,35.4048z" />
				<polygon fill="#AD6636" points="12.71546,57.31354 98.20032,57.31354 96.62756,47.31354 14.28821,47.31354 	" />
			</g>
		);
	}
}

function ShrimponBarbie(props) {
	const shrimponBarbies = {
		Cat,
		Tortoise,
	};

	const ThisShrimponBarbie = shrimponBarbies[props.petType.name] || Cat;

	if (_.isUndefined(ThisShrimponBarbie)) {
		return null;
	}

	return <ThisShrimponBarbie {...props} />;
}

export default ShrimponBarbie;



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Hat/ShrimponBarbie.js